<!--
    Se voce chegou aqui deve estar se perguntando "por que um DatePicker 2?"
    A resposta e simples. Nao faco ideia do que esta acontecendo no 1 e porque tem tantas props;
    Logo, fazer este componente foi mais facil do que tentar entender como usar o antigo.

    Para usar este componente basta seguir o modelo:
    <DatePicker2 v-model="variavelData" label="labelCampo" :disabled="isDisabled" />

    PS: Se decidir fazer o DatePicker 3, por favor documentar tambem :)
-->
<template>
  <v-menu
    v-calendario-acessivel
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="displayValue"
        :label="label"
        readonly
        outlined
        dense
        hide-details="auto"
        v-bind="attrs"
        v-on="on"
        append-icon="fas fa-calendar"
        :class="{ 'no-pointer-events': disabled }"
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-date-picker
      :value="dateValue"
      @input="updateDate"
      color="primary"
      locale="pt-BR"
      first-day-of-week="1"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: 'Data' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      menu: false,
      dateValue: null,
      displayValue: '',
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.dateValue = newVal;

          const [year, month, day] = newVal.split('-');
          this.displayValue = `${day}/${month}/${year}`;
        } else {
          this.dateValue = null;
          this.displayValue = '';
        }
      },
    },
  },
  methods: {
    updateDate(date) {
      this.menu = false;
      this.dateValue = date;

      if (date) {
        const [year, month, day] = date.split('-');
        this.displayValue = `${day}/${month}/${year}`;
      } else {
        this.displayValue = '';
      }

      this.$emit('input', date);
    },
  },
};
</script>

<style scoped>
.no-pointer-events {
  pointer-events: none;
}
</style>
